<template>
  <span>
    <v-btn icon @click.stop="setDialog(true)" class="ma-n4">
      <v-icon small>fas fa-trash</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="600" persistent>
      <release-note-delete-dialog-confirmation
        :releaseNote="releaseNote"
        :packId="packId"
        @setDialog="setDialog"
      ></release-note-delete-dialog-confirmation>
    </v-dialog>
  </span>
</template>

<script>
import ReleaseNoteDeleteDialogConfirmation from "./ReleaseNoteDeleteDialogConfirmation.vue";

export default {
  components: { ReleaseNoteDeleteDialogConfirmation },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      this.dialog = val;
    },
  },
  props: {
    releaseNote: { required: true, type: Object },
    packId: { required: true, type: Number },
  },
};
</script>
